export const WORDLE_ATTEMPTS = 7;
export const WORDLE_WORD_LENGTH = 6;

// Consistent with the user ID from client-side DiscordSDKMock
export const MOCK_USER_ID = "mock_user_id";
